export const LANDING_SECTIONS_COLLAPSE_PROPERTY = 'flex-grow'
export const LANDING_SECTIONS_FADE_PROPERTY = 'opacity'

export function isLandingSectionsExitComplete({
  hasConversation,
  isOwnTransition,
  prefersReducedMotion,
  propertyName,
}: {
  hasConversation: boolean
  isOwnTransition: boolean
  prefersReducedMotion: boolean
  propertyName: string
}): boolean {
  if (!hasConversation || !isOwnTransition) return false
  const finalProperty = prefersReducedMotion
    ? LANDING_SECTIONS_FADE_PROPERTY
    : LANDING_SECTIONS_COLLAPSE_PROPERTY
  return propertyName === finalProperty
}
